module.exports = __webpack_public_path__ + "img/11.ffb2daec.png";